import type { PunchOrderFlowDiscountsState } from 'store/punchOrderFlowDiscounts/punchOrderFlowDiscounts.types';
import type { PunchOrderFlowState } from 'store/punchOrderFlowNext/punchOrderFlow.types';
import type { SettingsState } from 'store/settings/settings.reducer';
import type { ValidateOrder } from 'types/ValidateOrder';
import { getBaseOrderRequestBody } from './getBaseOrderRequestBody.util';

export const getValidateOrderRequestBody = (state: {
  punchOrderFlowNext: PunchOrderFlowState;
  punchOrderFlowDiscounts: PunchOrderFlowDiscountsState;
  settings: SettingsState;
}): ValidateOrder | undefined => getBaseOrderRequestBody(state);
